let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6FAtr")).then(() => parcelRequire('9Nk4u'));